import { generalServiceV1API } from '@/store/api-instance'
import { AxiosResponse } from 'axios'
import { IPackagesLimit } from '../interfaces/api/PackagesLimitResponse'

// al-uathu-hu-service.azurewebsites.net/api/v1/portal/packagelimit/GetPackageLimitByShiptoIds/{shiptoIds}
// al-uathu-hu-service.azurewebsites.net/api/v1/portal/packagelimit/GetPackageLimitByPackageId/{packageId}

export const catalogAPI = {
  async getPackagesLimitFromShipTo (queryParams: string): Promise<IPackagesLimit> {
    const response: AxiosResponse = await generalServiceV1API.get(
      `/packagelimit/GetPackageLimitByShiptoIds/${queryParams}`, { }
    )
    return response.data
  },

  async getPackagesLimitFromPackageID (queryParams: string): Promise<IPackagesLimit> {
    const response: AxiosResponse = await generalServiceV1API.get(
      `/packagelimit/GetPackageLimitByPackageId/${queryParams}`, { params: queryParams }
    )
    return response.data
  }
}
